import GradientBorderRadius from "@/ui/gradient-border-radius";

const AddWalletsBtn = ({ onClick }: { onClick: () => void }) => {
  return (
    <GradientBorderRadius radius="bigger" gradient="50" hover="r-100">
      <button
        onClick={onClick}
        className="w-[9.3750rem] h-[1.8750rem] rounded-3xl dark:text-white font-semibold text-xs "
      >
        Add Wallets
      </button>
    </GradientBorderRadius>
  );
};

export default AddWalletsBtn;
